export default __webpack_public_path__ + "static/media/inProgress.34157f75.svg";